const mutations = {

    PRELOADER_MUDAR (state, value) {

        state.loading = value

    },

    PRELOADER_PDF (state, value) {

        state.pdf = value

    }
}

export default mutations